import { render, staticRenderFns } from "./JingYingDian.vue?vue&type=template&id=11b8ccfe&scoped=true"
import script from "./JingYingDian.vue?vue&type=script&lang=js"
export * from "./JingYingDian.vue?vue&type=script&lang=js"
import style0 from "./JingYingDian.vue?vue&type=style&index=0&id=11b8ccfe&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b8ccfe",
  null
  
)

export default component.exports